/* tslint:disable */
/* eslint-disable */
/**
 * Atelier Roles API
 * L\'Atelier des rôles (BO admin) : référentiel des briques (standard verrouillées, personnalisées administrables), profils (ensembles de rôles appliqués à la création des acteurs) et matrice rôles/portails. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetBriquePermissionsCommand
 */
export interface SetBriquePermissionsCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof SetBriquePermissionsCommand
     */
    permissions: Array<string>;
}

/**
 * Check if a given object implements the SetBriquePermissionsCommand interface.
 */
export function instanceOfSetBriquePermissionsCommand(value: object): value is SetBriquePermissionsCommand {
    if (!('permissions' in value) || value['permissions'] === undefined) return false;
    return true;
}

export function SetBriquePermissionsCommandFromJSON(json: any): SetBriquePermissionsCommand {
    return SetBriquePermissionsCommandFromJSONTyped(json, false);
}

export function SetBriquePermissionsCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetBriquePermissionsCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'permissions': json['permissions'],
    };
}

export function SetBriquePermissionsCommandToJSON(json: any): SetBriquePermissionsCommand {
    return SetBriquePermissionsCommandToJSONTyped(json, false);
}

export function SetBriquePermissionsCommandToJSONTyped(value?: SetBriquePermissionsCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'permissions': value['permissions'],
    };
}

